export const tamTamyLanguagesMap = {
  en: "en_US",
  it: "it_IT",
  fr: "fr_FR",
  es: "es_ES",
  pt: "pt_PT",
};

const langPriority = {
  en_US: 5,
  it_IT: 4,
  fr_FR: 3,
  es_ES: 2,
  pt_PT: 1,
};

const getLabelTranslation = (field = {}, lang) => {
  const translation = field
    ? field?.[tamTamyLanguagesMap?.[lang?.value]] ||
      Object.entries(field)
        ?.sort(([ttLangA], [ttLangB]) =>
          langPriority[ttLangA] > langPriority[ttLangB]
            ? -1
            : langPriority[ttLangA] < langPriority[ttLangB]
            ? 1
            : 0
        )
        ?.find(([_ttLang, translation]) => !!translation)?.[1]
    : null;
  return translation;
};

export const translateSurvey = (survey, lang) => {
  return {
    ...survey,
    title: survey?.translatedTitle?.[tamTamyLanguagesMap?.[lang?.value]],
    description: getLabelTranslation(survey?.translatedDescription, lang),
    definition: {
      ...survey?.definition,
      sections: survey?.definition?.sections?.map((section) => ({
        ...section,
        label: getLabelTranslation(section?.translatedLabel, lang),
        description: getLabelTranslation(section?.translatedDescription, lang),
        questions: section.questions.map((question) => ({
          ...question,
          label: getLabelTranslation(question?.translatedLabel, lang),
          answers: question.answers.map((answer) => ({
            ...answer,
            label: getLabelTranslation(answer?.translatedLabel, lang),
          })),
        })),
      })),
    },
  };
};

export const translateCart = (cart, lang) => {
  return {
    ...cart,
    title: getLabelTranslation(cart?.translatedTitle, lang),
    description: getLabelTranslation(cart?.translatedDescription, lang),
    cartContent: getLabelTranslation(cart?.translatedCartContent, lang),
  };
};

export const getTranslatedField = (item, lang, field) => {
  const translatableFields = {
    title: "translatedName",
    description: "translatedDescription",
    logistics: "translatedEventLogistics",
    contacts: "translatedEventContact",
  };
  return Object.keys(translatableFields)?.includes(field)
    ? item?.[translatableFields?.[field]]?.[tamTamyLanguagesMap?.[lang?.value]]
    : "";
};
